import React, { useState } from "react";

export default function RecipeSummary({ recipe }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="text-gray-600 mb-6 mt-7">
      {/* Recipe Summary with Expand/Collapse */}
      <p
        className={`relative ${expanded ? "" : "line-clamp-3"} md:line-clamp-none`}
      >
        {recipe.summary}
      </p>

      {/* Show More / Show Less Toggle (Only for Small Screens) */}
      <button
        className="text-green-600 text-sm hover:underline mt-1 block md:hidden"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? "Show less" : "Show more"}
      </button>

      {/* Source Attribution */}
      {recipe.originalRecipe?.url && (
        <div className="text-sm text-gray-400 mt-2">
          Adapted from{' '}
          <a
            href={recipe.originalRecipe?.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-600 hover:underline"
          >
            {recipe.originalRecipe?.baseDomain || 'unknown'}.com
          </a>
        </div>
      )}
    </div>
  );
}
